module.exports = __webpack_public_path__ + "assets/img/C3.7ba8ce42.jpg";